import React, { ReactNode, FC } from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';

type MenuPropsType = {
    draverWidth: number;
    handleDrawerToggle: React.MouseEventHandler<HTMLButtonElement>;
    container?: Element | (() => Element | null);
    mobileOpen: boolean;
    children: ReactNode;
};

const MenuContainer: FC<MenuPropsType> = (props) => {
    return (
        <Box component="nav" sx={{ width: { sm: props.draverWidth }, flexShrink: { sm: 0 } }} aria-label="navigation">
            <Drawer
                container={props.container}
                variant="temporary"
                open={props.mobileOpen}
                onClose={props.handleDrawerToggle}
                ModalProps={{
                    keepMounted: true, // Better open performance on mobile.
                }}
                sx={{
                    display: { xs: 'block', sm: 'none' },
                    '& .MuiDrawer-paper': {
                        boxSizing: 'border-box',
                        width: props.draverWidth,
                    },
                }}
            >
                {props.children}
            </Drawer>
            <Drawer
                variant="permanent"
                // variant="persistent"
                sx={{
                    display: { xs: 'none', sm: 'block' },
                    '& .MuiDrawer-paper': {
                        // boxSizing: "border-box",
                        width: props.draverWidth,
                    },
                }}
                open
            >
                {props.children}
            </Drawer>
        </Box>
    );
};

export default MenuContainer;
